import CollapsibleText from '@molecules/CollapsibleText/CollapsibleText';
import { Cta } from '@type-declarations/cta';
import { StoreModifier } from '@type-declarations/modifier';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import CtaButton from '../CtaButton/CtaButton';
import styles from './SectionContent.module.scss';

interface SectionContentProps extends PropsWithChildren {
  id?: string;
  title?: string;
  subtitle?: string;
  text?: string;
  isCollapsible?: boolean;
  cta?: Cta;
  centered?: boolean;
  addSpaceForButtons?: boolean;
  className?: string;
  modifier?: StoreModifier | 'fullWidth';
}

function SectionContent({
  id,
  title,
  subtitle,
  text,
  isCollapsible = false,
  cta,
  centered,
  className,
  children,
  modifier,
  addSpaceForButtons,
}: SectionContentProps) {
  if (!title && !subtitle && !text && !cta?.title && !children) return null;

  const hasCta =
    cta &&
    (modifier !== 'inStore' ||
      cta.internalLink[0]?.typename === 'StoreMapPage');

  return (
    <div
      className={clsx(
        styles.container,
        centered && styles.centered,
        modifier && styles[modifier],
        addSpaceForButtons && styles.addSpaceForButtons,
        className,
      )}
    >
      {title && <h2 className={styles.title}>{title}</h2>}
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {text && (
        <CollapsibleText
          id={id}
          text={text}
          isCollapsible={isCollapsible}
          className={styles.text}
          store={modifier === 'inStore'}
        >
          {hasCta && (
            <CtaButton
              cta={cta}
              modifier={modifier === 'inStore' ? modifier : undefined}
            />
          )}
        </CollapsibleText>
      )}
      {hasCta && !text && (
        <CtaButton
          cta={cta}
          modifier={modifier === 'inStore' ? modifier : undefined}
        />
      )}
      {children}
    </div>
  );
}

export default SectionContent;
